import { AbstractGetAllStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import Actions from "./marcheCaldaieActions";
import CaldaieActions from "../caldaie/caldaieActions";

class MarcheCaldaieStore extends AbstractGetAllStore<string>{
    constructor() {
        super(x => x);
        Dispatcher
            .onfunction(Actions.getAll, result => this.setAll(result))
            .onfunction(CaldaieActions.add, result => this.updateOrAdd(result.marcaCaldaia!))
            .onfunction(CaldaieActions.update, result => this.updateOrAdd(result.marcaCaldaia!))

    }
    public useAll = () => this.useAllWithAction(() => Actions.getAll());
}

export default new MarcheCaldaieStore()
